import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce } from 'intact-vue-next';
import { getRestProps, addStyle } from '../utils';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    style = _this$get.style;
  var _this$style = this.style,
    _style = _this$style.style,
    containerStyle = _this$style.containerStyle;
  var _this$config = this.config,
    cls = _this$config.cls,
    k = _this$config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-affix"] = true, _classNameObj[k + "-fixed"] = _style.value, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this), {
    'style': addStyle(style, containerStyle.value),
    'ref': this.elementRef
  }), _$ce(2, 'div', children, 0, _$cn(cls('affix-wrapper')), {
    'style': _style.value
  }));
}
;